// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30yLE","buttons":"styles_buttons__3QNUX"};